/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalLogout
 */
export interface PortalLogout {
    /**
     * 
     */
    ended: boolean;
}

/**
 * Check if a given object implements the PortalLogout interface.
 */
export function instanceOfPortalLogout(value: object): value is PortalLogout {
    if (!('ended' in value) || value['ended'] === undefined) return false;
    return true;
}

export function PortalLogoutFromJSON(json: any): PortalLogout {
    return PortalLogoutFromJSONTyped(json, false);
}

export function PortalLogoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalLogout {
    if (json == null) {
        return json;
    }
    return {
        
        'ended': json['ended'],
    };
}

export function PortalLogoutToJSON(json: any): PortalLogout {
    return PortalLogoutToJSONTyped(json, false);
}

export function PortalLogoutToJSONTyped(value?: PortalLogout | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ended': value['ended'],
    };
}

